import React, { useState } from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';

import 'react-drawer/lib/react-drawer.css';

import {
  Col,
  Container,
  Row,
  Spinner,
} from 'reactstrap';
import StoreRefundList from '../components/StoreRefundList';
import { Toaster } from 'react-hot-toast';
const StoreRefunds = () => {

  const [loading, setLoading] = useState(false);

  const [stores, setStores] = useState();


  return (
    <React.Fragment>
      {loading ? (
        <div className="loader-container">
          <Spinner type="grow" className="ms-2" color="dark" />
        </div>
      ) : (
        <></>
      )}
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Store Refunds List</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col>
              <DashBreadcrumb
                title="Refunds"
                breadcrumbItem="Store Refunds List"
              />
            </Col>
          </Row>
          <StoreRefundList stores={stores} />
        </Container>
      </div>

      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default StoreRefunds;
